import {
  getUid,
} from './getUid';

import {
  get_date_int_today,
} from '@thomasphan/helpers-fatsecret';

import {
  getDatabase,
  ref,
  set,
} from 'firebase/database';

import {
  app,
} from './initializeApp';

export async function weightUpdate(weight_kg)
{
  const uid = await getUid();

  return set
  (
    ref(getDatabase(app), `fatsecret/${ uid }/weight/${ get_date_int_today() }`),
    weight_kg,
  );
}